import type React from "react"

const Footer: React.FC = () => {
  const year = new Date().getFullYear()

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">
          <p className="footer-title">Badkul Technology</p>
          <p className="footer-subtitle">QR Generator Tool</p>
        </div>
        <div className="footer-right">
          <p>© {year} Badkul Technology. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
